/* eslint-disable @typescript-eslint/no-unused-vars */
import { Box, Button, Grid, Icon, Paper, Typography, useTheme, alpha, CircularProgress } from '@mui/material';

interface IFerramentasDaListagemProps {
  aoClicarEmFaturamento?: () => void;
  aoClicarEmNFE?: () => void;
  aoClicarEmNFCE?: () => void;
  desabilitarFaturamento?: boolean;
  desabilitarNFE?: boolean;
  desabilitarNFCE?: boolean;
  isLoading?: boolean; // Nova propriedade para loading
}

export const FerramentasDaListagemFaturamento: React.FC<IFerramentasDaListagemProps> = ({
  aoClicarEmFaturamento,
  aoClicarEmNFE,
  aoClicarEmNFCE,
  desabilitarFaturamento = false,
  desabilitarNFE = false,
  desabilitarNFCE = false,
  isLoading = false, // Valor padrão false
}) => {
  const theme = useTheme();

  return (
    <Box
      gap={1}
      marginX={2}
      padding={1} 
      paddingX={2}
      display="flex"
      alignItems="center"
      component={Paper}
      sx={{
        backgroundColor: alpha(theme.palette.background.paper, 0.95),
        border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
        boxShadow: theme.shadows[1],
        borderRadius: 2,
      }}
    >
      <Grid container item direction="row" spacing={1} justifyContent="center"> 
        
        {/* Botão Faturamento */}
        <Grid item xs={12} sm={4} md={3} lg={2} xl={1.5}> 
          <Button
            fullWidth
            size="small"
            color='primary'
            variant='contained'
            disableElevation
            disabled={desabilitarFaturamento || isLoading} // Desabilita durante loading
            onClick={aoClicarEmFaturamento}
            startIcon={
              isLoading ? (
                <CircularProgress size={16} color="inherit" />
              ) : (
                <Icon>receipt</Icon>
              )
            }
            sx={{
              background: isLoading 
                ? theme.palette.action.disabledBackground 
                : `linear-gradient(45deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
              fontWeight: 'bold',
              '&:hover': isLoading ? {} : {
                background: `linear-gradient(45deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
                transform: 'translateY(-1px)',
                boxShadow: theme.shadows[4],
              }
            }}
          >
            {isLoading ? 'Processando...' : 'Faturamento'}
          </Button>
        </Grid> 

        {/* Botão NFE */}
        <Grid item xs={12} sm={4} md={3} lg={2} xl={1.5}> 
          <Button 
            size="small"
            fullWidth
            color='success'
            variant='contained'
            disabled={desabilitarNFE || isLoading} // Desabilita durante loading
            disableElevation
            onClick={aoClicarEmNFE}
            startIcon={<Icon>description</Icon>}
            sx={{
              background: isLoading 
                ? theme.palette.action.disabledBackground 
                : `linear-gradient(45deg, ${theme.palette.success.main} 0%, ${theme.palette.success.dark} 100%)`,
              fontWeight: 'bold',
              '&:hover': isLoading ? {} : {
                background: `linear-gradient(45deg, ${theme.palette.success.dark} 0%, ${theme.palette.success.main} 100%)`,
                transform: 'translateY(-1px)',
                boxShadow: theme.shadows[4],
              }
            }}
          >
            NFE
          </Button>
        </Grid> 

        {/* Botão NFEE */}
        <Grid item xs={12} sm={4} md={3} lg={2} xl={1.5}> 
          <Button
            fullWidth
            size="small"
            color='secondary'
            variant='contained'
            disabled={desabilitarNFCE || isLoading} // Desabilita durante loading
            disableElevation
            onClick={aoClicarEmNFCE}
            startIcon={<Icon>article</Icon>}
            sx={{
              background: isLoading 
                ? theme.palette.action.disabledBackground 
                : `linear-gradient(45deg, ${theme.palette.secondary.main} 0%, ${theme.palette.secondary.dark} 100%)`,
              fontWeight: 'bold',
              '&:hover': isLoading ? {} : {
                background: `linear-gradient(45deg, ${theme.palette.secondary.dark} 0%, ${theme.palette.secondary.main} 100%)`,
                transform: 'translateY(-1px)',
                boxShadow: theme.shadows[4],
              }
            }}
          >
            NFC-e
          </Button>
        </Grid>     
      </Grid> 
    </Box>
  );
};